import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { TituloService } from './services/titulo.service';
import { ITitulo } from './interfaces/titulo.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-titulos',
  templateUrl: './titulos.component.html',
  providers: [MessageService]
})
export class TitulosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedTitulo: ITitulo | null = null;
  dataSource: ITitulo[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'titulo', header: 'Título', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private tituloService: TituloService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.tituloService.getTitulos().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los títulos'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar títulos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los títulos'
        });
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedTitulo = null;
    this.displayDialog = true;
  }

  openUpdate(row: ITitulo): void {
    this.selectedTitulo = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ITitulo): void {
    this.deleteTitulo(row.titulo);
  }

  onDialogClosed(): void {
    this.selectedTitulo = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  deleteTitulo(titulo: string): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este título?',
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#d33',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.tituloService.deleteTitulo(titulo).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Título eliminado exitosamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.error || 'No se pudo eliminar el título'
              });
            }
            this.loading = false;
          },
          error: (error) => {
            console.error('Error al eliminar título:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el título'
            });
            this.loading = false;
          }
        });
      }
    });
  }
} 